import { getSourceAppPackageName, toAppLinkFriendlyUrl } from 'adv-lib/src/v2/utils/source-url-util'

/** APK 브릿지에 넘길 대상 — 앱이 받아주는 주소와 패키지명 */
interface SourceAppTarget {
  url: string
  packageName: string
}

/**
 * APK 에 외부 앱 설치 여부를 묻는다 — `true` 설치 / `false` 미설치 / `null` 알 수 없음
 *
 * `null` 을 `false` 로 뭉뚱그리지 않는다. `jnHasPackage` 가 없는 구버전 APK 라도
 * `jnRequestOpenApp` 은 있어, 앱이 설치돼 있으면 앱으로 열린다
 */
function queryPackageInstalled(packageName: string): boolean | null {
  if (packageName === '' || typeof window.android?.jnHasPackage !== 'function') {
    return null
  }
  return window.android.jnHasPackage(packageName)
}

/**
 * 외부 앱으로 열 수 있으면 그 대상, 아니면 null (= 인앱 팝업)
 *
 * 설치 여부를 알 수 있는 곳은 APK 뿐이다.
 * APK 웹뷰는 스스로 외부 앱을 열지 못해 브릿지로 넘겨야 한다 (참조문서 C-3)
 */
function planAppOpen(url: string): SourceAppTarget | null {
  if (!window.android) {
    return null
  }

  const packageName = getSourceAppPackageName(url)
  const hasOpenAppBridge = typeof window.android.jnRequestOpenApp === 'function'

  // 열어 줄 앱이 없거나, 앱을 열 수단이 없는 구버전 APK
  if (packageName === '' || !hasOpenAppBridge) {
    return null
  }

  if (queryPackageInstalled(packageName) === false) {
    return null
  }

  return { url: toAppLinkFriendlyUrl(url), packageName }
}

export function openSourceByApp(url: string, fallback: () => void): void {
  const target = planAppOpen(url)

  if (target === null) {
    fallback()
    return
  }

  window.android.jnRequestOpenApp(target.url, target.packageName)
}
